/** True su smartphone/tablet touch. */
export function isTouchDevice() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

/** PWA installata (iOS standalone o display-mode standalone). */
export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

/**
 * Su mobile/PWA il modale overlay è inaffidabile (tap fantasma, iframe, redirect).
 * Usiamo pagina dedicata /play/:id.
 */
export function shouldUseDedicatedVideoPage() {
  return isTouchDevice() || isStandalonePwa();
}
